import { Component, Input, OnInit, Output,EventEmitter,ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';
import { FruizioneDropdown, CouponPianificazioneForm, GenerazioneDropdown } from 'app/views/campaign-3/models/campaign-3-planning.model';
import { Campaign3Info, MessageInstanceObject, Campaign3StatusMapping } from 'app/views/campaign-3/models/campaign-3.model';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';

import { MessageService } from 'primeng/primeng';


@Component({
  selector: 'app-message-3-planning',
  templateUrl: './message-3-planning.component.html',
  styleUrls: ['./message-3-planning.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Message3PlanningComponent implements OnInit {
  
  @Input() campaignInfo: Campaign3Info = null;

  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() formSchema: any;
  @Input() messageInstanceObject: MessageInstanceObject;

  //@Input() comboGiornoSettimanaInizioFruizione: Array<{value: number,name: string}> = []
 // @Input() comboGiornoSettimanaFineFruizione: Array<{value: number,name: string}> = []
  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() statusMapping: Campaign3StatusMapping;

  @Output() messageInstanceObjectChange:EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();
  //@Output() rollingChange:EventEmitter<CalculateFruitionDateRequest> = new EventEmitter<CalculateFruitionDateRequest>();
  
  @ViewChild('data_inizio_emissione') data_inizio_emissione: FormFields;
  @ViewChild('data_fine_emissione') data_fine_emissione: FormFields;

  @ViewChild('giorno_settimana_inizio') giorno_settimana_inizio: FormFields;
  @ViewChild('giorno_settimana_fine') giorno_settimana_fine: FormFields;
  @ViewChild('switchAsEmission') switchAsEmission: FormFields;
  @ViewChild('switchVariabile') switchVariabile: FormFields;

  

  pianificazioneCouponForm: CouponPianificazioneForm = new CouponPianificazioneForm();

  valid: boolean = true;

  switch = {
    asCampaign: false,
    asEmission: false,
    variable: false
  }

  show = {
    form: false,
  
    giorno_settimana_inizio: false,
    giorno_settimana_fine: false,
    errorDate: false
  }

  fieldModel = {
    data_inizio_emissione: null,
    data_fine_emissione:null,
   
    giorno_settimana_inizio: null,
    giorno_settimana_fine: null
  }

  errorDateText: string = "Controlla l'intervallo date!";

  //currentFruitionDateRequest: CalculateFruitionDateRequest = null;

  //generazioneDropdown: Array<GenerazioneDropdown> = [];
  //fruizioneDropdown: Array<FruizioneDropdown> = [];

  constructor(
    private srvCampaign3: Campaign3Service,
    private srvMessage: MessageService,
    private translate: TranslateService
    ) {
  


  }
  ngOnInit() {

    this.show.form = true;

    var self = this;
    setTimeout(function(){
      self.data_inizio_emissione.required = true;
      self.data_fine_emissione.required = true;
    
      if(self.messageInstanceObject && self.ui_mode==self.srvCampaign3.ui_modes.EDIT){
        self.switch.variable = (self.messageInstanceObject.flgRolling == "1") ? true : false;
     
        self.fieldModel.data_inizio_emissione = self.srvCampaign3.getDateFromDateStringDB(self.messageInstanceObject.startEmissionDate);
        self.fieldModel.data_fine_emissione = self.srvCampaign3.getDateFromDateStringDB(self.messageInstanceObject.endEmissionDate);
       
   
        self.data_inizio_emissione.minDate = self.campaignInfo.dateStart;
        self.data_inizio_emissione.maxDate = self.campaignInfo.dateEnd;
        self.data_fine_emissione.minDate = self.campaignInfo.dateStart;
        self.data_fine_emissione.maxDate = self.campaignInfo.dateEnd;
       
       
     
        var self2 = self;
        setTimeout(function(){
          if(self2.giorno_settimana_inizio){
            self2.fieldModel.giorno_settimana_inizio = self2.giorno_settimana_inizio.options.find(x=>x.value == self2.messageInstanceObject.couponValidityStartWeekDay);
          }
           
          if(self2.giorno_settimana_fine){
            self2.fieldModel.giorno_settimana_fine = self2.giorno_settimana_fine.options.find(x=>x.value == self2.messageInstanceObject.couponValidityEndWeekDay);
          }
           
        },100);
   
      
      }
    },100);
    
  }
  resetFruizione(){
  
    this.messageInstanceObject.startFruitionDate = null;

    this.messageInstanceObject.endFruitionDate = null;

    this.messageInstanceObject.couponValidityStartOffsetDay = null;

    this.messageInstanceObject.couponValidityEndOffsetDay = null;

    this.messageInstanceObject.couponValidityDateStart = null;

    this.messageInstanceObject.couponValidityDateEnd = null;

    this.messageInstanceObject.couponValidityDateStartMode = null;

    this.messageInstanceObject.couponValidityDateEndMode = null;

    this.fieldModel.giorno_settimana_inizio = null;
    this.messageInstanceObject.couponValidityStartWeekDay = null;

    this.fieldModel.giorno_settimana_fine = null;
    this.messageInstanceObject.couponValidityEndWeekDay = null;

    //this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  onChangeAsCampaign() {

    /*** si ritorna allo stato iniziale */
    this.resetFruizione();

    var self = this;
    setTimeout(function () {

      self.fieldModel.data_inizio_emissione = self.campaignInfo.dateStart;
      self.messageInstanceObject.startEmissionDate = self.srvCampaign3.getDateStringDBFromDate(self.campaignInfo.dateStart);

      self.fieldModel.data_fine_emissione = self.campaignInfo.dateEnd;
      self.messageInstanceObject.endEmissionDate = self.srvCampaign3.getDateStringDBFromDate(self.campaignInfo.dateEnd);


      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    }, 100);

  }
  onChangeAsEmission(value: boolean){
    this.switch.variable = false;
    this.messageInstanceObject.flgRolling = "0";
    var self = this;
    setTimeout(function(){
  
      self.resetFruizione();

      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    },100);
 
    
  }
  onChangeVariable(value: boolean){

    var self = this;
 
    //se la promo è statica, allora non può essere variabile (solo però se già è stato definito actionType);
    if(this.messageInstanceObject.flgCouponingMethod == "S" && (this.srvCampaign3.getStatusNumberFromCode(this.messageInstanceObject.status,this.statusMapping)>=this.statusMapping.actionTypes.number) && value == true){
     
      setTimeout(function(){
        self.switch.variable = false;
        self.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),  
          detail: this.translate.instant('campaign.static_promotion_warning')
        });
              })
     
      return;
    }

    setTimeout(function(){
      self.messageInstanceObject.couponValidityDateStartMode = null;
      self.messageInstanceObject.couponValidityDateEndMode = null;
      self.resetVariableFieldsInizio();
      self.resetVariableFieldsFine();
      self.switch.asEmission = false;
      //scatta quando cambia l'input switch con date di emissione
     
      if(self.switch.variable == true){
        self.messageInstanceObject.flgRolling = "1";
      }
      else{   
        self.messageInstanceObject.flgRolling = "0";
      }
      self.messageInstanceObjectChange.emit(self.messageInstanceObject);
    },100);

  }
 

  onChangeInizioFruizioneFissa(date: Date){
    /*
    if(this.data_inizio_fruizione_fissa){
      this.data_inizio_fruizione_fissa.minDate = date ? date : this.campaignInfo.dateStart;
    }
    */
  }
  onChangeFineFruizioneFissa(date: Date){
    /*
    if(this.data_fine_fruizione_fissa){
      this.data_fine_fruizione_fissa.minDate = date ? date : this.campaignInfo.dateStart;
    }
    */
  }
  resetVariableFieldsInizio(){
   
    if(this.giorno_settimana_inizio) this.giorno_settimana_inizio.required = false;

    this.messageInstanceObject.couponValidityDateStart = null;

    this.messageInstanceObject.couponValidityStartOffsetDay = null;

    this.fieldModel.giorno_settimana_inizio = null;
    this.messageInstanceObject.couponValidityStartWeekDay = null;

    this.show.giorno_settimana_inizio = false;

    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  resetVariableFieldsFine(){   
   
    if(this.giorno_settimana_fine) this.giorno_settimana_fine.required = false;

    this.messageInstanceObject.couponValidityDateEnd = null;

    this.messageInstanceObject.couponValidityEndOffsetDay = null;

    this.fieldModel.giorno_settimana_fine = null;
    this.messageInstanceObject.couponValidityEndWeekDay = null;

    this.show.giorno_settimana_fine = false;

    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }


  onChangeGiornoSettimana(){
    if(this.giorno_settimana_inizio && this.giorno_settimana_inizio.fieldModel && this.giorno_settimana_inizio.fieldModel.value){
      this.messageInstanceObject.couponValidityStartWeekDay = this.giorno_settimana_inizio.fieldModel.value;
    }
    if(this.giorno_settimana_fine && this.giorno_settimana_fine.fieldModel && this.giorno_settimana_fine.fieldModel.value){
      this.messageInstanceObject.couponValidityEndWeekDay = this.giorno_settimana_fine.fieldModel.value;
    }
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
    //this.rollingChange.emit(this.currentFruitionDateRequest);
  }
  /*
  onChangeOffsetInizioFruizione(value: any){
    this.messageInstanceObject.couponValidityStartOffsetDay = value;
    this.messageInstanceObjectChange.emit(this.messageInstanceObject);
  }
  */
  performValidationPlanning(): boolean{

    if(this.data_inizio_emissione) this.data_inizio_emissione.performValidation();
    if(this.data_fine_emissione) this.data_fine_emissione.performValidation();
  
    if(this.giorno_settimana_inizio) this.giorno_settimana_inizio.performValidation();
    if(this.giorno_settimana_fine) this.giorno_settimana_fine.performValidation();
    
    let error = false;

    if(
        (this.data_inizio_emissione && !this.data_inizio_emissione.valid ) || 
        (this.data_fine_emissione && !this.data_fine_emissione.valid) || 
      
        (this.giorno_settimana_inizio && !this.giorno_settimana_inizio.valid) || 
        (this.giorno_settimana_fine && !this.giorno_settimana_fine.valid)
      )
      error = true;
      
    //altre condizioni sulle date
    this.checkDateErrors();
    if(this.show.errorDate == true)
      error = true;
  
    if(error == true){
      this.valid = false;
    }
    else{
      this.valid = true;
    }
    return this.valid;

  }
  checkDateErrors(){

    this.show.errorDate = false;

    const rules = new Set([
      {
        condition: () => (this.fieldModel.data_inizio_emissione && this.campaignInfo.dateStart && (this.fieldModel.data_inizio_emissione < this.campaignInfo.dateStart)),
        errorMessage: "La data di inizio emissione non può essere inferiore alla data di inizio della campagna"
      },
      {
        condition: () => (this.fieldModel.data_inizio_emissione && this.campaignInfo.dateEnd && (this.fieldModel.data_inizio_emissione > this.campaignInfo.dateEnd)),
        errorMessage: "La data di inizio emissione non può essere superiore alla data di fine della campagna"
      },
    
      {
        condition: () => (this.fieldModel.data_fine_emissione && this.campaignInfo.dateStart && (this.fieldModel.data_fine_emissione < this.campaignInfo.dateStart)),
        errorMessage: "La data di fine emissione non può essere inferiore alla data di inizio della campagna"
      },
      {
        condition: () => (this.fieldModel.data_fine_emissione && this.campaignInfo.dateEnd && (this.fieldModel.data_fine_emissione > this.campaignInfo.dateEnd)),
        errorMessage: "La data di fine emissione non può essere superiore alla data di fine della campagna"
      }
     
    ]);
    
    var self = this;
    rules.forEach(rule => {
      if (rule.condition()) {
        self.errorDateText = rule.errorMessage;
        self.show.errorDate=true;       
      }
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-planning/message-3-planning.component.ts